import React from 'react';
import { useAdministrationOverlay } from '@piwikpro/router-crate';
import InviteUserRoute from './InviteUser/InviteUserRoute';

/** List-level invite overlay; URL suffix is handled by administrationOverlayRewrite. */
const UsersListOverlay: React.FC = () => {
  const overlay = useAdministrationOverlay();

  if (overlay === '/m/invite') {
    return <InviteUserRoute />;
  }

  return null;
};

export default UsersListOverlay;
